// Subscription plus T&C Fix Shopcircle (Danko)

const tnc = document.querySelector('.subscription-plus-agreement input');
const btn = document.querySelector('.btn-add-to-cart');
const keyframes = [
  { transform: 'translateX(0px)' },
  { transform: 'translateX(10px)' },
  { transform: 'translateX(-10px)' },
  { transform: 'translateX(0px)' },
];
const animationOptions = {
  duration: 500,
  iterations: 2,
  easing: 'ease-in-out'
};

const tncTxt = document.querySelector('a.subscriptions_link');
tncTxt.innerText = "I agree to the subscription terms and condition";
tnc.parentElement.style.alignItems = "normal !important";

btn.addEventListener("click", (event) => {
    if (tnc.parentElement.style.display != "none" && tnc.checked === false) {
        event.preventDefault();
        event.stopPropagation();
        tnc.parentElement.animate(keyframes, animationOptions);
        tncTxt.setAttribute('style', 'color: red !important');
        setTimeout(() => {tncTxt.setAttribute('style', 'color: black !important')},500)
    }});

// Function to create the modal element
function createModal() {
  const modalContainer = document.createElement('div');
  modalContainer.classList.add('sp__modal');

  const modalContent = document.createElement('div');
  modalContent.classList.add('modal-content');
  modalContainer.appendChild(modalContent);

  const modalTitle = document.createElement('div');
  modalTitle.classList.add('modal-title');
  modalTitle.innerHTML = `<h2 style="inline">Subscribe & Save</h2><a id="sp__close" style="color: white;font-size: 2em;cursor: pointer">x</a>`;
  modalContent.appendChild(modalTitle);

  const modalBody = document.createElement('div');
  modalBody.classList.add('modal-body');
  modalContent.appendChild(modalBody);

modalBody.innerHTML = `<br><strong>Unlock up to 15% savings...</strong>
<strong>Every 3 months</strong>
<p>
Save 15% on your order when you select every 3 months auto-delivery to one address. By choosing this option, you agree to our terms and agreement and bind into a subscription to continue to save 15% on your next four deliveries of this part (sku). You can choose to cancel after your fourth successful delivery to fulfill.
</p>
<strong>Every 6 months</strong>
<p>
Save 10% on your next order when you select every 6 months auto-delivery to one address. By choosing this option, you agree to our terms and agreement and bind into a subscription to continue to save 10% on your next four deliveries of this part (sku). You can choose to cancel after your second successful delivery to fulfill.
</p>
<strong>Every 12 months</strong>
<p>
Save 5% on your next order when you select every 12 months auto-delivery to one address. By choosing this option, you agree to our terms and agreement and bind into a subscription to continue to save 5% on your next four deliveries of this part (sku). You can choose to cancel after your first successful delivery to fulfill.
</p>
<strong>Choose how often it's delivered</strong>
<p>
From once every 3 months to once every 12 months
</p>
<strong>Skip any time</strong>
<p>
We'll send you a reminder before each delivery.
</p>
<strong>Prices</strong>
<p>
Prices subject to change without notice in reference to our terms and conditions, section 4: Prices for our products are subject to change without notice. We reserve the right at any time to modify or discontinue the Service (or any part or content thereof) without notice at any time. We shall not be liable to you or to any third-party for any modification, price change, suspension or discontinuance of the Service.
</p>`;

modalContainer.style.position = "fixed";
modalContainer.style.height = "100vh";
modalContainer.style.width = "100vw";
modalContainer.style.top = "50%";
modalContainer.style.left = "50%";
modalContainer.style.transform = "translate(-50%,-50%)";
modalContainer.style.display = "none";
modalContainer.style.alignItems = "center";
modalContainer.style.justifyContent = "center";
modalContainer.style.zIndex = "3";
modalContainer.style.background = "rgba(0,0,0,0.9)";

modalContent.style.height = "60%";
modalContent.style.width = "70%";
modalContent.style.overflow = "scroll";
modalContent.style.zIndex = "9999999";
modalContent.style.color = "white";
modalContent.style.textAlign = "justify";

modalTitle.style.display = "flex";
modalTitle.style.justifyContent = "space-between";
modalTitle.style.alignItems = "center";
modalTitle.style.paddingRight = "1.5em";

    document.body.appendChild(modalContainer);
}

createModal();
setTimeout(() => {
tncTxt.removeAttribute('href');
},2000);

tncTxt.addEventListener("click", () => {document.querySelector('.sp__modal').style.display="flex";setTimeout(() => {document.body.addEventListener('click', clickClose)},500);});
document.getElementById('sp__close').addEventListener('click', () => {document.querySelector('.sp__modal').style.display="none"});
const excludedClass = 'modal-content';
function clickClose () {
 if (!event.target.classList.contains(excludedClass) && !event.target.closest('.' + excludedClass)) {
   document.querySelector('.sp__modal').style.display="none";
   document.body.removeEventListener("click", clickClose);
}}
